function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 12,
  viewBox: "0 0 12 12",
  role: "img"
}, props), /*#__PURE__*/React.createElement("circle", {
  cx: 96,
  cy: 341,
  r: 5,
  fill: "#FFF",
  fillRule: "evenodd",
  stroke: "currentColor",
  strokeWidth: 2,
  transform: "translate(-90 -335)"
}));
export default "/Users/mgomezlucero/Work/SkedGo/Projects/tripkit-react/src/images/ic-service-stop.svg";
export { SvgComponent as ReactComponent };